import React, { useContext, Suspense } from 'react';
import { MemoryRouter as Router, Routes, Route } from 'react-router-dom';
import { AppContext } from '../DataProviders/AppStateProvider';
import GenericNotFound from './GenericNotFound';
import * as Steps from './Steps/_Steps';

/**
 * Arthur-Fischer-Erfinderpreis Quick Check App - Main Component
 *
 * Dynamically generates the routes (see AppData.js) and loads the first step automatically.
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const AppContentRouter = props => {
  // Use the context for global data storage and state management
  const { appData } = useContext(AppContext);

  // Generate the routes
  const routes = () => Object.keys(appData.journeys[appData.currentJourney]).map(stepKey => {
    const StepRouteComponent = Steps[appData.journeys[appData.currentJourney][stepKey].componentName];
    return (
      <Route key={stepKey} path={`/step/${stepKey}`} element={<StepRouteComponent />}/>
    );
  });

  return (
    <Router>
      <Suspense fallback={null}>
        <div className="container__afp-quickcheck">
          <div id="container__afp-quickcheck-route" className="slide">
            <Routes>
              {routes()}
              <Route exact path='*' element={<GenericNotFound />} /> {/* Redirects to first step */}
            </Routes>
          </div>
        </div>
      </Suspense>
    </Router>
  );
}

export default AppContentRouter
